module.exports = __webpack_public_path__ + "static/img/question4-8.7c52558.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question4-8.png
// module id = W34y
// module chunks = 1